import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { OpsUsersEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class OpsUserSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    opsUserCreated$() {
        return this.socketService.receiveMessageObserver(OpsUsersEvents.OPS_USERS_CREATED);
    }

    opsUserUpdated$() {
        return this.socketService.receiveMessageObserver(OpsUsersEvents.OPS_USERS_UPDATED);
    }

    opsUserDeleted$() {
        return this.socketService.receiveMessageObserver(OpsUsersEvents.OPS_USERS_DELETED);
    }

    opsPerimssionsUpdated$() {
        return this.socketService.receiveMessageObserver(OpsUsersEvents.PERMISSIONS_UPDATED);
    }

    opsSessionTimeoutUpdated$() {
        return this.socketService.receiveMessageObserver(OpsUsersEvents.SESSION_TIMEOUT_UPDATED);
    }
}
